import {
  Container,
  Row,
  Col
} from 'UI'
import { createUseStyles } from 'react-jss'
import style from './style'
import Objectives from '../Objectives'
import TableOfContent from '../TableOfContent'
import Prerequirements from '../Prerequirements'
import ConcernedAudiences from '../ConcernedAudiences'
import Pricing from '../Pricing'
import { useRef, useState } from 'react'
import Bar from '../Bar'
import Reviews from '../Reviews'
import PopUpPlayer from '../PopUpPlayer'
import SimilarCourses from '../SimilarCourses'
import TransformYourLife from 'components/common/TransformYourLife'
import Title from '../Title'
import Main from '../Main'
import Aside from '../Aside'
import Text from './text.json'
import IntersectionComponent from 'components/common/IntersectionComponent'

const useStyle = createUseStyles(style)

export default ({ loading, IsFree, courseTitle }) => {
  const [forceRender, setForceRender] = useState(false)
  const { main, aside, tableOfContent, tableOfContentAndRequirement, requirements, pricing, similarCourses, reviews } = useStyle()
  const ref = useRef()
  const reviewsRef = useRef()
  const barHeight = 112
  const scrollToPricing = () => {
    setForceRender(true)
    setTimeout(() => {
      if (!ref.current) return
      const top = ref.current.getBoundingClientRect().top - barHeight
      window.scrollTo({ top: window.scrollY + top, behavior: 'smooth' })
    })
  }
  const scrollToReviews = () => {
    setForceRender(true)
    setTimeout(() => {
      const top = reviewsRef.current.getBoundingClientRect().top - barHeight
      window.scrollTo({ top: window.scrollY + top, behavior: 'smooth' })
    })
  }
  const title = Text.youWillLearn
  return (
    <>
      <Bar scrollToPricing={scrollToPricing} />
      <Container>
        <Title />
        <Row>
          <Col className={main} grid={8} direction='column'>
            <Main scrollToPricing={scrollToPricing} />
          </Col>
          <Col className={aside} grid={4} direction='column'>
            <Aside scrollToPricing={scrollToPricing} scrollToReviews={scrollToReviews} />
          </Col>
        </Row>
        <IntersectionComponent forceRender={forceRender} component={Objectives} title={title} />
        <IntersectionComponent
          forceRender={forceRender} component={() =>
            <Row className={tableOfContentAndRequirement} gap={16} noWrap>
              <Col grid={6} className={tableOfContent}>
                <TableOfContent height={1000} noBorder loading={loading} scrollToPricing={scrollToPricing} />
              </Col>
              <Col grid={6} className={requirements} direction='column' gap={13}>
                <Prerequirements loading={loading} />
                <ConcernedAudiences loading={loading} />
              </Col>
            </Row>}
        />
        <IntersectionComponent
          forceRender={forceRender}
          component={() =>
            <Row className={similarCourses}>
              <Col grid={12}>
                <SimilarCourses hideController courseLoading={loading} titleProps={{ spacing: 0 }} />
              </Col>
            </Row>}
        />
        <IntersectionComponent
          forceRender={forceRender} component={() =>
            <div className={reviews} ref={reviewsRef}>
              <Reviews />
            </div>}
        />
        <IntersectionComponent
          forceRender={forceRender} component={() =>
            !IsFree
              ? (
                <>
                  <div ref={ref} />
                  <div className={pricing}>
                    <Pricing />
                  </div>
                </>)
              : <TransformYourLife />}
        />
      </Container>
      {!loading && <PopUpPlayer scrollToPricing={scrollToPricing} />}
    </>
  )
}
